import {Endpoints} from '../../../../../globals/api/endpoints';

export class LayerEndpoints extends Endpoints {

  private static readonly LAYERS = LayerEndpoints.VIEWER + '/layer';
  public static readonly LAYER = LayerEndpoints.LAYERS + '/' + LayerEndpoints.PROJECT_ID;
  public static readonly LAYER_PREVIEW = LayerEndpoints.LAYERS + '/' + LayerEndpoints.VERSION_ID + '/preview';
}
